import { Gender } from '../customer/customer.types';
import { MemberGender } from './member.types';

export const translateGenderFromString = (gender: MemberGender) => (gender === MemberGender.male ? Gender.man : Gender.woman);
export const translateGenderFromEnum = (gender: Gender) => (gender === Gender.man ? 'male' : 'female');
